
import functions from '@/util/functions';
/**
 * 按页码随机
 * @param quesList 试题list
 * @param list 抽题条件list
 * @return Array
 */
export const randomType3 = (questionsList, list) => {
    let result = [], // 最后返回的结果
    newList = [], // 将分页按条件分组
    pageList = [], // 随机到的分页
    quesSumList = [], // 按分页分开的试题id
    quesList = []
    let arr = questionsList.filter((info, index) => {
        if (info.questionsTypeId != '26' ) {
            quesList.push(info)
        } else if (index != 0) {
            quesSumList.push(quesList)
            quesList = []
        }
        if (index == questionsList.length - 1) {
            quesSumList.push(quesList)
        }
        return info.questionsTypeId == '26'
    })
    list.forEach(item => {
        let itemArr = []
        arr.forEach((info) => {
            if (info.pageNumber >= item.startNum && info.pageNumber <= item.endNum) {
                itemArr.push(info)
            }
            if (info.pageNumber == item.endNum) {
                newList.push(itemArr)
            }
        })
    })
    newList.forEach((info, index) => {
        let randomArray = functions.GetRandomArray(info, list[index].sum)
        pageList = [...pageList,...randomArray]
    }) 
    pageList.forEach((info, index) => {
        if (index == 0) {
            result = [info, ...result, ...quesSumList[info.pageNumber - 1]]
        } else {
            result = [...result, info, ...quesSumList[info.pageNumber - 1]]
        }
    })
    return result
}